var ownClasses = {"container":"index-module_container__uSw-h","inline":"index-module_inline__cRSy4","info":"index-module_info__GDGgZ","grid":"index-module_grid__H7L7V","grid-columns-3":"index-module_grid-columns-3__OK1i4","grid-columns-4":"index-module_grid-columns-4__MZU0U","placeholder":"index-module_placeholder__yAs-3"};

export { ownClasses as default };
//# sourceMappingURL=index.module.scss.js.map
